var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "declaration-scope" }, [
    _c("div", { staticStyle: { display: "flex" } }, [
      _c(
        "div",
        {
          staticClass: "show-right section",
          staticStyle: { width: "60%", "background-color": "#FFFFFF" }
        },
        [
          _c(
            "div",
            {
              staticClass: "main-content left",
              staticStyle: { "margin-left": "20px", "margin-bottom": "50px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    disabled: _vm.useHqSet,
                    "label-width": "130px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "el-form-item-wrapper",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: {
                              "font-size": "15px",
                              "font-weight": "bold"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RPAService")))]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-checkbox", {
                            attrs: { no: "rpaEnabled", disabled: !_vm.isEdit },
                            on: { change: _vm.rpaEnableChange },
                            model: {
                              value: _vm.form.rpaEnabled,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "rpaEnabled", $$v)
                              },
                              expression: "form.rpaEnabled"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_EnableRPAService"))
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c("el-form-item", [
                        _c("span", {
                          staticStyle: { "font-size": "13px" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("CargoMsg.Cargo_RPASubmission", [
                                _vm.rpaLink
                              ])
                            )
                          }
                        })
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              disabled: !(_vm.isEdit && _vm.form.rpaEnabled),
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_ShippingExchangeAccount"
                              )
                            },
                            model: {
                              value: _vm.form.rpaAccount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "rpaAccount", $$v)
                              },
                              expression: "form.rpaAccount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            ref: "rpaPassword",
                            staticStyle: { width: "300px" },
                            attrs: {
                              disabled: !(_vm.isEdit && _vm.form.rpaEnabled),
                              type: _vm.inputType,
                              "show-password":
                                _vm.isEdit && _vm.form.rpaEnabled,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_ShippingExchangePassword"
                              )
                            },
                            on: {
                              "click-show-password": _vm.toggleShowPassword
                            },
                            model: {
                              value: _vm.form.rpaPassword,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "rpaPassword", $$v)
                              },
                              expression: "form.rpaPassword"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }